'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _reactIcofont = require('react-icofont');

var _reactIcofont2 = _interopRequireDefault(_reactIcofont);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _DeleteAddressModal = require('./DeleteAddressModal');

var _DeleteAddressModal2 = _interopRequireDefault(_DeleteAddressModal);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INIT_MESSAGE = "You have not saved any delivery address.";

var AddressCard = function (_React$Component) {
    _inherits(AddressCard, _React$Component);

    function AddressCard(props, context) {
        _classCallCheck(this, AddressCard);

        var _this = _possibleConstructorReturn(this, (AddressCard.__proto__ || Object.getPrototypeOf(AddressCard)).call(this, props, context));

        _this.hideAddressModal = function () {
            return _this.setState({ showAddressModal: false });
        };

        _this.onDeleteClick = function (idx) {
            return _this.setState({ showDeleteModal: true, address: _this.state.addressContainer[idx], idx: idx }, function () {
                // console.log(idx)
            });
        };

        _this.state = {
            addressContainer: [],
            showDeleteModal: false,
            showAddressModal: false,
            address: {},
            idx: 0
        };

        _this.renderAddressCard = _this.renderAddressCard.bind(_this);
        _this.onDeleteClick = _this.onDeleteClick.bind(_this);
        _this.hideDeleteModal = _this.hideDeleteModal.bind(_this);
        return _this;
    }

    _createClass(AddressCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.populateDeliveryAddress();
        }
    }, {
        key: 'populateDeliveryAddress',
        value: function populateDeliveryAddress() {
            var _this2 = this;

            Utils.showSpinner();
            var setDefaultDeliveryAddress = "";
            var currentUser = _parse2.default.User.current();

            if (currentUser) {
                var deliveryAddress = currentUser.get("deliveryAddress");

                if (deliveryAddress && deliveryAddress.length > 0) {
                    setDefaultDeliveryAddress = "0";
                    this.setState({
                        addressContainer: deliveryAddress
                        // selectedDeliveryAddress : setDefaultDeliveryAddress
                    }, function () {
                        _this2.props.callBackParent(false);
                    });
                } else {
                    // set default order type with empty data
                    this.setState({
                        addressContainer: []
                    }, function () {
                        // reset the delivery calculation and configuration
                        _this2.props.callBackParent(false);
                    });
                }
            }
        }
    }, {
        key: 'removeAddress',
        value: function removeAddress() {
            var _this3 = this;

            var index = this.state.idx;
            var toDelete = this.state.addressContainer[index];
            var currentUser = _parse2.default.User.current();

            var router = this.props.history;
            var locId = this.props.locId;

            if (currentUser) {
                var _router = this.props.history;
                var _locId = this.props.locId;

                currentUser.remove("deliveryAddress", toDelete);
                currentUser.save().then(function (res) {
                    _this3.state.addressContainer.splice(index, 1);
                    _this3.setState({
                        addressContainer: _this3.state.addressContainer
                    }, function () {
                        //hide bootstrap modal
                        $('#deleteModal').modal('hide');
                        _this3.hideDeleteModal();
                        _Actions2.default.deleteDeliveryAddress(toDelete);
                        _this3.populateDeliveryAddress();
                    });
                }, function (error) {
                    // check the error and alert the invalid session token
                    Utils.checkErrorIsInvalidSessionToken(error, _router, _locId, false);
                    //hide bootstrap modal
                    $('#deleteModal').modal('hide');
                    _this3.hideDeleteModal();
                    // console.log(error);
                });
            }
        }
    }, {
        key: 'hideDeleteModal',
        value: function hideDeleteModal() {
            this.setState({
                showDeleteModal: false
            });
        }
    }, {
        key: 'renderSaveAddresses',
        value: function renderSaveAddresses() {
            var _this4 = this;

            var savedAddress = this.state.addressContainer;

            return savedAddress.map(function (address, index) {
                return _react2.default.createElement(
                    'div',
                    { className: "col-md-6", key: "add" + index },
                    _react2.default.createElement(
                        'div',
                        { className: "bg-white addresses-item mb-4 card" + _this4.props.boxClass },
                        _react2.default.createElement(
                            'div',
                            { className: 'gold-members p-4' },
                            _react2.default.createElement(
                                'div',
                                { className: "media" },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'mr-3' },
                                    _react2.default.createElement(_reactIcofont2.default, { icon: _this4.props.icoIcon,
                                        className: _this4.props.iconclassName }),
                                    _react2.default.createElement('i', { className: 'icofont-address' })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'media-body' },
                                    _react2.default.createElement(
                                        'h6',
                                        { className: 'mb-1 text-black' },
                                        address.name || address.firstName
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'text-secondary mb-0' },
                                        '  ',
                                        address.addLine1,
                                        ', ',
                                        address.addLine2,
                                        ', ',
                                        address.city
                                    ),
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'mb-0 text-black font-weight-bold mt-1' },
                                        _react2.default.createElement(
                                            _reactRouterDom.Link,
                                            { className: 'text-danger', to: '#',
                                                onClick: _this4.onDeleteClick.bind(_this4, index), tabIndex: 12 },
                                            _react2.default.createElement(_reactIcofont2.default, {
                                                icon: 'ui-delete' }),
                                            ' DELETE'
                                        )
                                    )
                                )
                            )
                        )
                    )
                );
            });
        }
    }, {
        key: 'renderAddressCard',
        value: function renderAddressCard() {
            var savedAddress = this.state.addressContainer;

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                savedAddress.length == 0 ? _react2.default.createElement(
                    'div',
                    { className: "col-md-6" },
                    _react2.default.createElement(
                        'div',
                        { className: 'bg-white payments-item mb-4 shadow-sm card' },
                        _react2.default.createElement(
                            'div',
                            { className: 'gold-members p-4' },
                            _react2.default.createElement(
                                'div',
                                { className: "media" },
                                _react2.default.createElement(
                                    'div',
                                    { className: "media-body" },
                                    _react2.default.createElement(
                                        'p',
                                        { className: 'mb-0 text-primary font-weight-bold text-primary' },
                                        INIT_MESSAGE
                                    )
                                )
                            )
                        )
                    )
                ) : this.renderSaveAddresses()
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                this.state.showDeleteModal ? _react2.default.createElement(_DeleteAddressModal2.default, { onHide: this.hideDeleteModal, callBackParent: this.removeAddress.bind(this) }) : null,
                !this.props.isLoading ? this.renderAddressCard() : null
            );
        }
    }]);

    return AddressCard;
}(_react2.default.Component);

AddressCard.propTypes = {
    title: _propTypes2.default.string.isRequired,
    icoIcon: _propTypes2.default.string.isRequired,
    iconclassName: _propTypes2.default.string,
    address: _propTypes2.default.string
    // onEditClick: PropTypes.func.isRequired,
    // onDeleteClick: PropTypes.func.isRequired
};

exports.default = AddressCard;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/AddressCard.jsx
// module id = 559
// module chunks = 0